import React from 'react'
import { FormattedMessage } from 'react-intl'
import { connectCurrentRefinements } from 'react-instantsearch-dom'

const ClearRefinements = ({ items, refine }) => (
  <div id='clear' className='mt-4'>
    <div className='button button-pink'>
      <button onClick={() => refine(items)} disabled={!items.length}>
        <FormattedMessage id='clear-filters' /> <em className='fas fa-caret-right' />
      </button>
    </div>
  </div>
)

export default connectCurrentRefinements(ClearRefinements)
